import React, { Component } from "react";
// core components
import MUIDataTable from "mui-datatables";
import PropTypes from "prop-types";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Grid from "@material-ui/core/Grid";
import GridList from "@material-ui/core/GridList";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardBody from "components/Card/CardBody.jsx";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import moment from "moment";
import _ from "lodash";
import { TextField } from "@material-ui/core";
import { connect } from "react-redux";
import {
  fetchZonabySearch,
  delZonaTracking,
  fetchShipZona,
  fetchZonaVolume,
  fetchZonaVolumeToday,
  fetchMontlyCat,
  fetchMontly,
  fetchZoneShiptype,
  fetchMontlySum,
  fetchUseForCat,
  fetchZoneTrackingLast
} from "../../api/portal";
import { pushLeftPanel } from "actions/dashboard";
import { pushZonaTarget } from "actions/portal";
import { pushLoader } from "../../actions/main";
import BlockUi from "react-block-ui";
import ReactExport from "assets/libs/react-export-excel";
import Button from "components/CustomButtons/Button.jsx";
import { withRouter } from "react-router-dom";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const fileName = `Area List ${moment().format("LLL")}`;
const fileName2 = `Zone Tracking (Detail) ${moment().format("LLL")}`;
const fileName3 = `Zone Tracking ${moment().format("LLL")}`;

class Zonatracking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      datatable: [],
      datatable2: [],
      datatable3: [],
      datachart: [],
      montlycat: [],
      monthly: [],
      zoneshiptype: [],
      zoneshiptypecat: [],
      zoneshiptypedata: [],
      catnya: ["asd", "zxc"],
      selectedDrawname: "",
      selectedCategoryPeriode: "",
      selectedCategorySource: "gps",
      selectedUseForCat: "",
      useForCatData: [],
      loader1: null,
      loader2: null,
      loader3: null,
      loaderGraph1: null,
      loaderGraph2: null,
      loaderGraph3: null,
      startDate: moment()
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD")
    };
  }

  UNSAFE_componentWillMount() {
    // this.props.pushLoader(true);
    this.setState({ loader1: true });
    fetchUseForCat()
      .then(response => {
        if (response !== null) {
          let data = [];
          response.data.results.map(e => {
            if (e.usefor == "zona konservasi") {
              data.push({
                usefor: e.usefor
              });
            }
          });
          this.setState({
            useForCatData: data
          });
          // response.data.results.map(e => {
          //   if (e.usefor === "zona konservasi") {
          //     this.setState({ selectedUseForCat: e.usefor });
          //   }
          // });
        }

        // fetchZonaVolumeToday()
        //   .then(response => {
        //     if (response != null) {
        //       this.setState({ datachart: response.data });
        //     }
        //   })
        //   .catch(error => {
        //     //this.props.pushToken(error);
        //     //this.props.history.push("/pages/login#logout");
        //   });

        // fetchZonabySearch(this.state.selectedUseForCat)
        //   .then(response => {
        //     if (response != null) {
        //       this.setState({ datatable: response.data.results });
        //     }
        //     this.setState({ loader1: false });
        //   })
        //   .catch(error => {
        //     this.setState({ loader1: false });
        //     // this.props.history.push("/pages/login#logout");
        //     //this.props.pushToken(error);
        //   });

        // this.setState({ loader2: true });
        // fetchShipZona(
        //   this.state.selectedCategoryPeriode,
        //   this.state.selectedCategorySource,
        //   this.state.selectedUseForCat,
        //   this.state.startDate,
        //   this.state.endDate
        // )
        //   .then(response => {
        //     if (response != null) {
        //       let datanya = [];
        //       for (var key in response.data) {
        //         var aa = _.values(response.data[key]);
        //         //aa[2] = moment(aa[2], 'YYYY-MM-DD').format('DD-MM-YYYY');
        //         datanya.push({
        //           name: aa[2],
        //           shiptype: this.getNameshiptype(aa[3]),
        //           dateCreated: moment(aa[4], "YYYY-MM-DD HH:mm:ss").format(
        //             "DD-MM-YYYY HH:mm:ss"
        //           ),
        //           latitude: aa[5],
        //           longitude: aa[6],
        //           drawname: aa[7],
        //           duration: aa[9],
        //           speed: aa[10]
        //         });
        //       }
        //       this.setState({ datatable2: datanya });
        //     }
        //     this.setState({ loader2: false });
        //   })
        //   .catch(error => {
        //     //this.props.pushToken(error);
        //     this.setState({ loader2: false });
        //     //this.props.history.push("/pages/login#logout");
        //   });
        // this.setState({ loader3: true });
        // fetchZoneTrackingLast(
        //   this.state.startDate,
        //   this.state.endDate,
        //   this.state.selectedUseForCat
        // )
        //   .then(response => {
        //     if (response != null) {
        //       let datanya = [];
        //       for (var key in response.data) {
        //         var aa = _.values(response.data[key]);
        //         //aa[2] = moment(aa[2], 'YYYY-MM-DD').format('DD-MM-YYYY');
        //         datanya.push({
        //           name: aa[2],
        //           shiptype: this.getNameshiptype(aa[3]),
        //           dateCreated: moment(aa[4], "YYYY-MM-DD HH:mm:ss").format(
        //             "DD-MM-YYYY HH:mm:ss"
        //           ),
        //           latitude: aa[5],
        //           longitude: aa[6],
        //           drawname: aa[7],
        //           duration: aa[9],
        //           speed: aa[11]
        //         });
        //       }
        //       this.setState({ datatable3: datanya });
        //     }
        //     this.setState({ loader3: false });
        //   })
        //   .catch(error => {
        //     //this.props.pushToken(error);
        //     //this.setState({ loader2: false });
        //     //this.props.history.push("/pages/login#logout");
        //   });
      })
      .catch(error => {
        //this.props.pushToken(error);
        this.props.pushLoader(false);
        //this.props.history.push("/pages/login#logout");
      });
  }

  getNameshiptype = shiptype => {
    let shipTypeString;
    switch (shiptype) {
      case 1:
        shipTypeString = "Unspecified Ships";
        break;
      case 2:
        shipTypeString = "Fishing";
        break;
      case 3:
        shipTypeString = "Tugs & Special Craft";
        break;
      case 4:
        shipTypeString = "High Speed Craft";
        break;
      case 5:
        shipTypeString = "Pleasure Craft";
        break;
      case 6:
        shipTypeString = "Passenger Vessel";
        break;
      case 7:
        shipTypeString = "Cargo Vessel";
        break;
      case 8:
        shipTypeString = "Tanker";
        break;

      case 99:
        shipTypeString = "Pertamina";
        break;
      default:
        shipTypeString = "n/a";
        break;
    }

    return shipTypeString;
  };

  UNSAFE_componentWillReceiveProps() {
    // fetchZonabySearch(this.state.selectedUseForCat)
    //   .then(response => {
    //     if (response != null) {
    //       this.setState({ datatable: response.data.results });
    //     }
    //   })
    //   .catch(error => {
    //     //this.props.pushToken(error);
    //   });
  }

  handleRowSelect = e => {
    this.props.pushLeftPanel(!this.props.leftPanel);
    this.props.pushZonaTarget(e[4]);
  };

  handleStartDate = e => {
    this.setState({ startDate: e.target.value });
  };

  handleEndDate = e => {
    this.setState({ endDate: e.target.value });
  };

  handleZonecat = e => {
    this.setState({ selectedDrawname: e.target.value });
    fetchZoneShiptype(
      e.target.value,
      this.state.selectedCategoryPeriode,
      this.state.selectedCategorySource,
      this.state.selectedUseForCat
    )
      .then(response => {
        if (response != null) {
          this.setState({ zoneshiptype: response.data });
          let cat = [];
          let val = [];
          response.data.map(e => {
            cat.push(this.getNameshiptype(e[1]) + " type (" + e[1] + ")");
            val.push(e[2]);
          });

          this.setState({ zoneshiptypecat: cat, zoneshiptypedata: val });
        }
      })
      .catch(error => {
        //this.props.pushToken(error);
        //this.props.history.push("/pages/login#logout");
      });
  };

  handleDelete = deletedRows => {
    const deletedIndexes = Object.keys(deletedRows.lookup);
    deletedIndexes.map(e => {
      const a = this.state.datatable[e];
      delZonaTracking(a.id)
        .then(response => {})
        .catch(error => {
          //this.props.pushToken(error);
          //this.props.history.push("/pages/login#logout");
        });
    });
  };

  renderOptcat = e => {
    return <MenuItem value={e.id}> {e.name} </MenuItem>;
  };

  renderUseFor = e => {
    return <MenuItem value={e.usefor}> {e.usefor} </MenuItem>;
  };

  handlecatsource = e => {
    this.setState({ selectedCategorySource: e.target.value });
  };

  handlecatperiode = e => {
    this.setState({ selectedCategoryPeriode: e.target.value });
  };

  handleuseforcat = e => {
    this.setState({ selectedUseForCat: e.target.value });
  };

  handleSearchClick = () => {
    this.setState({
      loader1: true,
      datachart: [],
      datatable: [],
      datatable2: [],
      datatable3: []
    });
    fetchZonabySearch(this.state.selectedUseForCat)
      .then(response => {
        if (response != null) {
          this.setState({ datatable: response.data.results });
        }
        this.setState({ loader1: false });
      })
      .catch(error => {
        this.setState({ loader1: false });
        // this.props.history.push("/pages/login#logout");
        //this.props.pushToken(error);
      });

    if (
      this.state.startDate ===
      moment()
        .subtract(1, "days")
        .format("YYYY-MM-DD")
    ) {
      fetchZonaVolumeToday()
        .then(response => {
          if (response != null) {
            this.setState({ datachart: response.data });
          }
        })
        .catch(error => {
          //this.props.pushToken(error);
          //this.props.history.push("/pages/login#logout");
        });
    } else {
      fetchZonaVolume(
        this.state.selectedCategoryPeriode,
        this.state.selectedCategorySource,
        this.state.selectedUseForCat,
        this.state.startDate,
        this.state.endDate
      )
        .then(response => {
          if (response != null) {
            this.setState({ datachart: response.data });
          }
        })
        .catch(error => {
          //this.props.pushToken(error);
          //this.props.history.push("/pages/login#logout");
        });
    }

    // fetchZoneShiptype(
    //   this.state.selectedDrawname,
    //   this.state.selectedCategoryPeriode,
    //   this.state.selectedCategorySource,
    //   this.state.selectedUseForCat,
    //   this.state.startDate,
    //   this.state.endDate
    // )
    //   .then(response => {
    //     if (response != null) {
    //       this.setState({ zoneshiptype: response.data });
    //       let cat = [];
    //       let val = [];
    //       response.data.map(e => {
    //         cat.push(this.getNameshiptype(e[1]) + " type (" + e[1] + ")");
    //         val.push(e[2]);
    //       });

    //       this.setState({ zoneshiptypecat: cat, zoneshiptypedata: val });
    //     }
    //   })
    //   .catch(error => {
    //     //this.props.pushToken(error);
    //     //this.props.history.push("/pages/login#logout");
    //   });
    this.setState({ loader2: true });
    fetchShipZona(
      this.state.selectedCategoryPeriode,
      this.state.selectedCategorySource,
      this.state.selectedUseForCat,
      this.state.startDate,
      this.state.endDate
    )
      .then(response => {
        if (response != null) {
          let datanya = [];
          for (var key in response.data) {
            var aa = _.values(response.data[key]);
            //aa[2] = moment(aa[2], 'YYYY-MM-DD').format('DD-MM-YYYY');
            datanya.push({
              name: aa[2],
              shiptype: this.getNameshiptype(aa[3]),
              dateCreated: moment(aa[4], "YYYY-MM-DD HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              ),
              latitude: aa[5],
              longitude: aa[6],
              drawname: aa[7],
              duration: aa[9],
              speed: aa[10]
            });
          }
          this.setState({ datatable2: datanya });
        }
        this.setState({ loader2: false });
      })
      .catch(error => {
        //this.props.pushToken(error);
        this.setState({ loader2: false });
        //this.props.history.push("/pages/login#logout");
      });
    this.setState({ loader3: true });
    fetchZoneTrackingLast(
      this.state.startDate,
      this.state.endDate,
      this.state.selectedUseForCat
    )
      .then(response => {
        if (response != null) {
          let datanya = [];
          for (var key in response.data) {
            var aa = _.values(response.data[key]);
            //aa[2] = moment(aa[2], 'YYYY-MM-DD').format('DD-MM-YYYY');
            datanya.push({
              name: aa[2],
              shiptype: this.getNameshiptype(aa[3]),
              dateCreated: moment(aa[4], "YYYY-MM-DD HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              ),
              latitude: aa[5],
              longitude: aa[6],
              drawname: aa[7],
              duration: aa[9],
              speed: aa[11]
            });
          }
          this.setState({ datatable3: datanya });
        }
        this.setState({ loader3: false });
      })
      .catch(error => {
        //this.props.pushToken(error);
        //this.setState({ loader2: false });
        //this.props.history.push("/pages/login#logout");
      });
  };

  render() {
    const classes = {
      card: {
        minWidth: 275
      },
      bullet: {
        display: "inline-block",
        margin: "0 2px",
        transform: "scale(0.8)"
      },
      title: {
        fontSize: 14
      },
      pos: {
        marginBottom: 12
      },
      root: {
        flexGrow: 1,
        padding: 10
      },
      mod: {
        padding: 10
      },
      paper: {
        padding: 5
      }
    };
    const columns = [
      {
        name: "name",
        label: "Name",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "usefor",
        label: "Usefor",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "dateCreated",
        label: "Date Created",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "geom",
        label: "Geom",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "geomall",
        label: "Geomall",
        options: {
          filter: false,
          display: false
        }
      }
    ];

    const options = {
      filter: false,
      search: true,
      selectableRows: true,
      print: true,
      download: true,
      responsive: "scrollMaxHeight",
      onRowsDelete: this.handleDelete,
      viewColumns: true,
      textLabels: {
        body: {
          noMatch: this.state.loader1
            ? "Searching..."
            : "Sorry, no matching records found"
        }
      }
    };

    const columns2 = [
      {
        name: "name",
        label: "Name",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "drawname",
        label: "Drawname",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "duration",
        label: "Duration",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "speed",
        label: "Speed Returned in (knots x10)",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "dateCreated",
        label: "Date Created",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "longitude",
        label: "Longitude",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "latitude",
        label: "Latitude",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "shiptype",
        label: "Shiptype",
        options: {
          filter: false,
          display: true
        }
      }
    ];
    const options2 = {
      filter: false,
      search: true,
      selectableRows: true,
      print: true,
      download: true,
      responsive: "scrollMaxHeight",
      onRowsDelete: this.handleDelete,
      viewColumns: true,
      textLabels: {
        body: {
          noMatch: this.state.loader2
            ? "Searching..."
            : "Sorry, no matching records found"
        }
      }
    };

    const columns3 = [
      {
        name: "name",
        label: "Name",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "drawname",
        label: "Drawname",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "duration",
        label: "Duration",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "speed",
        label: "Speed Returned in (knots x10)",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "dateCreated",
        label: "Date Created",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "longitude",
        label: "Longitude",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "latitude",
        label: "Latitude",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "shiptype",
        label: "Shiptype",
        options: {
          filter: false,
          display: true
        }
      }
    ];
    const options3 = {
      filter: false,
      search: true,
      selectableRows: true,
      print: true,
      download: true,
      responsive: "scrollMaxHeight",
      // onRowsDelete: this.handleDelete,
      viewColumns: true,
      textLabels: {
        body: {
          noMatch: this.state.loader3
            ? "Searching..."
            : "Sorry, no matching records found"
        }
      }
    };

    const optionsChart = {
      chart: {
        type: "column"
      },
      title: {
        text: "Zone Tracking Volume"
      },
      credits: {
        enabled: false
      },
      xAxis: {
        categories: ["Hours"]
        // categories: [
        //   "n/a type",
        //   "n/a type",
        //   "Cargo Type",
        //   "Tugs Type",
        //   "Passenger Type",
        //   "Tanker Type",
        //   "Other Type",
        //   "Other Type",
        //   "Pilot Vessel",
        //   "n/a type"
        // ]
      },
      yAxis: {
        title: {
          text: "Hours"
        }
      },
      series: this.state.datachart
      // series: [
      //   {
      //     data: [0, 37, 70, 52, 60, 80, 99, 90, 50, 30]
      //   }
      // ]
    };

    const optionsChart2 = {
      chart: {
        type: "line"
      },
      title: {
        text: "Monthly Volume"
      },
      credits: {
        enabled: false
      },
      xAxis: {
        categories: this.state.montlycat
      },
      yAxis: {
        title: {
          text: "Volume Vessel"
        }
      },

      plotOptions: {
        line: {
          dataLabels: {
            enabled: true
          },
          enableMouseTracking: false
        }
      },
      // series: this.state.monthly

      series: this.state.monthly
      // series: [{
      //       name: ['Montly'],
      //       data: [2503, 3177, 3658, 3031, 3934 ]
      //   }],
    };

    const optionsChart3 = {
      chart: {
        type: "column"
      },
      credits: {
        enabled: false
      },
      title: {
        text: "Ship type"
      },
      xAxis: {
        categories: this.state.zoneshiptypecat
      },
      yAxis: {
        title: {
          text: "Volume Vessel"
        }
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true
          },
          enableMouseTracking: false
        }
      },
      series: [
        {
          name: "Volume",
          data: this.state.zoneshiptypedata
        }
      ]
    };

    return (
      <div>
        {/* <Grid item xs={12}>
          <Card className={classes.card}>
            <CardContent>
              <BlockUi
                tag="div"
                blocking={this.state.loaderGraph1}
                message="Loading"
              >
                <HighchartsReact
                  highcharts={Highcharts}
                  options={optionsChart2}
                />
              </BlockUi>
            </CardContent>
          </Card>
        </Grid> */}
        <Grid item xs={12}>
          <Card className={classes.card}>
            <CardContent>
              <BlockUi
                tag="div"
                blocking={this.state.loaderGraph1}
                message="Loading"
              >
                {/* <FormControl variant="outlined">
                  <Select
                    value={this.state.selectedCategoryPeriode}
                    onChange={this.handlecatperiode}
                  >
                    <MenuItem value="1"> Last 24 Hours </MenuItem>
                    <MenuItem value="7"> Last Week </MenuItem>
                    <MenuItem value="30"> Last Month </MenuItem>
                    <MenuItem value="365"> Last Year </MenuItem>
                    <MenuItem value="2365"> All Time </MenuItem>
                  </Select>
                </FormControl> */}
                <FormControl variant="standard" style={{ padding: 12 }}>
                  <Select
                    value={this.state.selectedUseForCat}
                    onChange={this.handleuseforcat}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Choose Area
                    </MenuItem>
                    {this.state.useForCatData.map(this.renderUseFor)}
                  </Select>
                </FormControl>{" "}
                <TextField
                  size="small"
                  id="date"
                  label="Start Date"
                  type="date"
                  className={classes.textField}
                  defaultValue={this.state.startDate}
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{
                    value: this.state.startDate,
                    onChange: this.handleStartDate
                  }}
                />{" "}
                <TextField
                  size="small"
                  label="End Date"
                  type="date"
                  className={classes.textField}
                  defaultValue={this.state.endDate}
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{
                    value: this.state.endDate,
                    onChange: this.handleEndDate
                  }}
                />{" "}
                <FormControl variant="standard" style={{ padding: 12 }}>
                  <Select
                    value={this.state.selectedCategorySource}
                    onChange={this.handlecatsource}
                  >
                    <MenuItem value="gps"> Pertamina </MenuItem>
                    <MenuItem value="ais"> All </MenuItem>
                  </Select>
                </FormControl>
                <Button
                  color="primary"
                  variant="contained"
                  disabled={this.state.loader}
                  style={{ marginRight: 20 }}
                  onClick={() => this.handleSearchClick()}
                >
                  Show Data
                </Button>
                <HighchartsReact
                  highcharts={Highcharts}
                  options={optionsChart}
                />
              </BlockUi>
            </CardContent>
          </Card>

          {/* <Grid item xs={12}>
          <Card className={classes.card}>
            <CardContent>
              <BlockUi
                tag="div"
                blocking={this.state.loaderGraph1}
                message="Loading"
              >
                <FormControl variant="outlined" className={classes.formControl}>
                  <Select
                    value={this.state.selectedDrawname}
                    onChange={this.handleZonecat}
                  >
                    {this.state.datatable.map(this.renderOptcat)}
                  </Select>
                </FormControl>
                <HighchartsReact
                  highcharts={Highcharts}
                  options={optionsChart3}
                />
              </BlockUi>
            </CardContent>
          </Card>
        </Grid> */}

          <br />
          <Grid xs={3}>
            <ExcelFile
              element={
                <Button
                  color="primary"
                  variant="contained"
                  disabled={this.state.loader3}
                  style={{ marginLeft: 30 }}
                >
                  Download as .xslx
                </Button>
              }
              filename={`${fileName3}`}
              fileExtension="xslx"
            >
              <ExcelSheet data={this.state.datatable3} name="Sheet 1">
                <ExcelColumn label="Name" value="name" />
                <ExcelColumn label="Drawname" value="drawname" />
                <ExcelColumn label="Duration" value="duration" />
                <ExcelColumn
                  label="Speed Returned in (knots x10)"
                  value="speed"
                />
                <ExcelColumn label="DateCreated" value="dateCreated" />
                <ExcelColumn label="Longitude" value="longitude" />
                <ExcelColumn label="Latitude" value="latitude" />
                <ExcelColumn label="Shiptype" value="shiptype" />
                <ExcelColumn
                  label="Speed Returned in (knots x10)"
                  value="speed"
                />
              </ExcelSheet>
            </ExcelFile>
          </Grid>
          <Grid item xs={12}>
            <MUIDataTable
              title={"Zone Tracking"}
              data={this.state.datatable3}
              columns={columns3}
              options={options3}
            />
          </Grid>
          <br />
          <Grid xs={3}>
            <ExcelFile
              element={
                <Button
                  color="primary"
                  variant="contained"
                  disabled={this.state.loader2}
                  style={{ marginLeft: 30 }}
                >
                  Download as .xslx
                </Button>
              }
              filename={`${fileName2}`}
              fileExtension="xslx"
            >
              <ExcelSheet data={this.state.datatable2} name="Sheet 1">
                <ExcelColumn label="Name" value="name" />
                <ExcelColumn label="Drawname" value="drawname" />
                <ExcelColumn label="Duration" value="duration" />
                <ExcelColumn
                  label="Speed Returned in (knots x10)"
                  value="speed"
                />
                <ExcelColumn label="DateCreated" value="dateCreated" />
                <ExcelColumn label="Longitude" value="longitude" />
                <ExcelColumn label="Latitude" value="latitude" />
                <ExcelColumn label="Shiptype" value="shiptype" />
              </ExcelSheet>
            </ExcelFile>
          </Grid>
          <Grid item xs={12}>
            <MUIDataTable
              title={"Zone Tracking (Detail)"}
              data={this.state.datatable2}
              columns={columns2}
              options={options2}
            />
          </Grid>
          <br />
          <Grid xs={3}>
            <ExcelFile
              element={
                <Button
                  color="primary"
                  variant="contained"
                  disabled={this.state.loader1}
                  style={{ marginLeft: 30 }}
                >
                  Download as .xslx
                </Button>
              }
              filename={`${fileName}`}
              fileExtension="xslx"
            >
              <ExcelSheet data={this.state.datatable} name="Sheet 1">
                <ExcelColumn label="Name" value="name" />
                <ExcelColumn label="Usefor" value="usefor" />
                <ExcelColumn label="DateCreated" value="dateCreated" />
                <ExcelColumn label="Geom" value="geom" />
                <ExcelColumn label="Geomall" value="geomall" />
              </ExcelSheet>
            </ExcelFile>
          </Grid>
          <Grid className={classes.mod} item xs={12}>
            <MUIDataTable
              title={"Area List"}
              data={this.state.datatable}
              columns={columns}
              options={options}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}

Zonatracking.propTypes = {
  pushLeftPanel: PropTypes.array,
  pushZonaTarget: PropTypes.string,
  delZonaTracking: PropTypes.string
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader,
    rightPanel: state.rightPanel,
    leftPanel: state.leftPanel
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    { pushLeftPanel, pushZonaTarget, delZonaTracking, pushLoader }
  )(Zonatracking)
);
